import Form from '@utilities/form';
import ButtonLoader from "@components/button-loader";

const ITEM_HOOK = '[js-hook-sample-products-item]'
const FOOTER_ITEM_HOOK = '[js-hook-sample-products-item-footer]'
const FOOTER_CART_ITEM_HOOK = '[js-hook-sample-products-item-cart-footer]'
const SUBMIT_BUTTON_HOOK = '[js-hook-sample-products-submit]'
const ERROR_HOOK = '[js-hook-sample-products-error]'
const SAMPLE_CHECK_ICON = '[js-hook-sample-check]'
const FOOTER_ITEM_NAME = '[js-hook-footer-item-name]'
const PRODUCT_PACKSHOTS = '[js-hook-product-packshot]'
const PRODUCT_IMAGE = '[js-hook-product-image]'
const SAMPLE_FOOTER_BUTTON = '[js-hook-sample-button-remove]'

const ACTIVE_CLASS = 'is--active';
const DISABLED_CLASS = 'is--disabled';
const HIDDEN_CLASS = 'u-hidden';

/**
 * Used to order (limited amount of) product samples
 *
 * @class ProductSampleForm
 * @extends {Form}
 */
class ProductSampleForm extends Form {
  constructor(element) {
    super(element);
    this.maxQuantity = parseInt(this.form.dataset.maxQuantity, 10);
    this.itemsInCart = 0;
    this.extraItemsAllowed = this.maxQuantity - this.itemsInCart;
    this.maxItemsReached = this.itemsInCart >= this.maxQuantity;
    this.formItems = [...this.form.querySelectorAll(ITEM_HOOK)];
    this.footerItems = [...this.form.querySelectorAll(FOOTER_ITEM_HOOK)];
    this.footerCartItems = [...this.form.querySelectorAll(FOOTER_CART_ITEM_HOOK)];
    this.submitButton = this.form.querySelector(SUBMIT_BUTTON_HOOK);
    this.errorMessage = this.form.querySelector(ERROR_HOOK);
    this.buttonLoader = new ButtonLoader(this.form.querySelector('[type="submit"]'));
    this.samplesIconCheck = [...this.form.querySelectorAll(SAMPLE_CHECK_ICON)];
    this.footerItemNames = [...this.form.querySelectorAll(FOOTER_ITEM_NAME)];
    this.productImage = document.querySelector(PRODUCT_IMAGE);
    this.productPackshots = [...document.querySelectorAll(PRODUCT_PACKSHOTS)];
    this.footerSampleButtons = [...document.querySelectorAll(SAMPLE_FOOTER_BUTTON)];
    this.selectedProducts = [];

    this._bindEvents();
    this.addCartItemsToFooter();
    this.updateFormState();
  }

  _bindEvents() {
    this.form.addEventListener('change', (e) => {
      this.formChangeHandler(e);
    });

    this.footerSampleButtons.forEach(button => {
      button.addEventListener('click', () => {
        this.removeSelectedItem(button.dataset.checkboxid);
      })
    })

    this.form.addEventListener('submit', () => {
      this.buttonLoader.show();
    });
  }

  static toggleCheckIcon(inputEl) {
    const inputId = inputEl.id;
    const showIcon = inputEl.checked;
    const iconElement = inputEl.parentNode.querySelector(`#item-check-${inputId}`);

    iconElement.classList[showIcon ? 'remove' : 'add'](HIDDEN_CLASS);
  }

  formChangeHandler(e) {
    this.updateFooterItems(e.target);
    this.maxItemsReachedCheck();
    this.updateFormState();
    this.updateImage(e.target);
    ProductSampleForm.toggleCheckIcon(e.target);
  }

  getTotalSelectedItems() {
    let totalItems = 0;

    this.formItems.forEach(item => {
      if(item.querySelector('input').checked) {
        totalItems++
      }
    });

    return totalItems;
  }

  removeSelectedItem(id) {
    const checkboxID = id;

    const checkbox = document.getElementById(checkboxID);
    checkbox.checked = false;

    this.updateFooterItems(checkbox);
    this.maxItemsReachedCheck();
    this.updateFormState();
    this.updateImage(checkbox);
    ProductSampleForm.toggleCheckIcon(checkbox);
  }

  updateImage(inputEl) {
    const inputId = inputEl.id;
    const inputChecked = inputEl.checked;
    const currentElement = document.querySelector(`#sample-product__packshot-${inputId}`);
    let index;

    this.productPackshots.forEach(packshot => {
      if (inputId === packshot.id.replace('sample-product__packshot-','')) {
        packshot.classList[inputChecked ? 'remove' : 'add'](HIDDEN_CLASS);
      }
      else if (inputId !== packshot.id.replace('sample-product__packshot-','')) {
        packshot.classList.add(HIDDEN_CLASS);
      }
    })

    if (inputChecked) {
      this.selectedProducts.push(currentElement);
    } else {
      index = this.selectedProducts.indexOf(currentElement);
      this.selectedProducts.splice(index, 1);
    }

    if (this.selectedProducts.length === 0) {
      this.productImage.classList.remove(HIDDEN_CLASS);
    } else {
      this.productImage.classList.add(HIDDEN_CLASS);
      this.selectedProducts[this.selectedProducts.length - 1].classList.remove(HIDDEN_CLASS);
    }
  }

  updateFooterItems(inputEl){
    const inputId = inputEl.id;
    const showFooterItem = inputEl.checked;

    this.footerItems.forEach(footerItem => {
      if (inputId === footerItem.id.replace('footer-item-','')) {
        footerItem.classList[showFooterItem ? 'add' : 'remove'](ACTIVE_CLASS);
      }
    });

    this.footerItemNames.forEach(footerItem => {
      if (inputId === footerItem.id.replace('footer-item-name-','')) {
        footerItem.classList[showFooterItem ? 'remove' : 'add'](HIDDEN_CLASS);
      }
      else if (inputId !== footerItem.id.replace('footer-item-name-','')) {
        footerItem.classList.add(HIDDEN_CLASS);
      }
    });
  }

  addCartItemsToFooter() {
    let itemsToShow = this.itemsInCart;

    if (itemsToShow === 0) return;

    this.footerCartItems.forEach(item => {

      if (itemsToShow > 0) {
        item.classList.add(ACTIVE_CLASS);
      }

      itemsToShow--;
    })
  }

  maxItemsReachedCheck () {
    if (this.itemsInCart >= this.maxQuantity) {
      this.maxQuantity = true;
    } else {
      this.maxItemsReached = this.getTotalSelectedItems() === this.extraItemsAllowed;
    }
  }

  updateFormState() {
    // hide/show error message & disabled form items
    this.form.classList[this.maxItemsReached ? 'add' : 'remove'](DISABLED_CLASS);
    this.errorMessage.classList[this.maxItemsReached ? 'remove' : 'add'](HIDDEN_CLASS);

    // disable on/off of submit button
    if (this.getTotalSelectedItems() > 0) {
      this.submitButton.removeAttribute('disabled');
    } else {
      this.submitButton.setAttribute('disabled', 'disabled');
    }
  }
}

export default ProductSampleForm;
